<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：应用-小程序设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="250px">
      <!--小程序设置-->
      <div class="common-form">技师极光推送设置</div>
      <el-form-item label="AppKey" :rules="[{required: true,message: '请输入AppKey'}]">
        <el-input v-model="form.technician_appKey" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="MasterSecret" :rules="[{required: true,message: '请输入MasterSecret'}]">
        <el-input v-model="form.technician_masterSecret" type="password" class="max-w460"></el-input>
      </el-form-item>
      <div class="common-form">商户极光推送设置</div>
      <el-form-item label="AppKey" :rules="[{required: true,message: '请输入AppKey'}]">
        <el-input v-model="form.supplier_appKey" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="MasterSecret" :rules="[{required: true,message: '请输入MasterSecret'}]">
        <el-input v-model="form.supplier_masterSecret" type="password" class="max-w460"></el-input>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>

  </div>

</template>

<script>
import AppSettingApi from "@/api/appsetting.js";

export default {
  data() {
    return {
      form: {}
    };
  },
  created() {
    this.getData();
  },

  methods: {
    getData() {
      let self = this;
      AppSettingApi.getJiGuang({}, true)
        .then(data => {
          if (data.code == 1) {
            self.form = data.data.vars.values;
          }
        })
        .catch(error => {});
    },
    //提交表单
    onSubmit() {
      let self = this;
      let params = this.form;
      AppSettingApi.editJiGuang(params, true)
        .then(data => {
          self.$message({
            message: "恭喜你，设置成功",
            type: "success"
          });
          self.$router.push("/appsetting/appjiguang/index");
        })
        .catch(error => {});
    }
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/appsetting/appjiguang/index.vue